// src/screens/Home.jsx
import Header from "../components/Header";
import styles from "../styles/Home.module.css";
import forest from "../resources/assets/forest.webp";
import electronics from "../resources/assets/electronics.webp";
import software from "../resources/assets/software.webp";
import mechanics from "../resources/assets/mechanics.webp";
import robotics from "../resources/assets/robotics.webp";

const Home = () => {
    return (
        <div className={styles.container}>
            <Header
                title="Omar Network"
                subtitle="Welcome to Omar's world of electronics, software, mechanics, and robotics!"
            />
            
            <div className={styles.mainPage}>
                <h2 className={styles.heading}>Welcome!</h2>
                <p className={styles.text}>
                    Welcome to Omar Network, where the calm of lush green forests meets the thrill of cutting-edge technology—or at least that’s the vibe I’m going for. Step into a world where innovation might happen, and every idea has the potential to spark... unless it fizzles out first.
                </p>
                <p className={styles.text}>
                    Before you get too excited, let me level with you: this isn’t the next big thing in tech. It’s just a humble green static webpage as I explore the wild frontier of AI and web hosting.
                </p>
                <p className={styles.text}>
                    Fun fact: I love the color green. You’ve probably figured that out by now. As grand as this site might seem, let’s be honest—it’s not really going anywhere. Consider it a pit stop on my journey through the web world. Enjoy the scenery while I take my baby steps into this digital realm!
                </p>
                <div className={styles.imageGallery}>
                    <img src={forest} alt="Calm Forest" />
                    <img src={electronics} alt="Electronics" />
                    <img src={software} alt="Software" />
                    <img src={mechanics} alt="Mechanics" />
                    <img src={robotics} alt="Robotics" />
                </div>
            </div>
        </div>
    );
};

export default Home;
